import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseApiService } from '../../base-service/base-api.service';

@Injectable()
export class DocumentViewerService extends BaseApiService {

    private _pdfDownloadUrlTemplate = 'foundation/print/GetDocument/';

    public getDocumentAsStream(url: string) {
        if (url.toLowerCase().indexOf('http') >= 0) {
            return this.getAbsolute(url, 'application/octet-stream').pipe(
                catchError(
                    (error) => this.handleError(error)
                ));
        } else {
            return this.get(url, 'application/octet-stream').pipe(
                catchError(
                    (error) => this.handleError(error)
                ));
        }
    }

    public getAbsoluteDocumentAsStream(url: string) {
        return this.getAbsolute(url, 'arraybuffer').pipe(
            catchError(
                (error) => this.handleError(error)
            ));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            var errorObject = {
                httpStatus: error.status,
                response: error.error
            };
            return observableThrowError(errorObject);
        } else {
            return observableThrowError('Server error');
        }
    }

}
